<template>
    <b-overlay :show="isLoading">
        <b-card class="m-4" no-body>
            <b-tabs content-class="mt-3" card>
                <b-tab title="Administradores" no-body lazy class="px-4 pb-2" @click="changeTab('USER')" active>
                    <UserIndex :settings="settings" :membership="membership" :userType="BACK_OFFICE_USER"></UserIndex>
                </b-tab>
                <b-tab title="General" no-body class="px-4 pb-4" @click="loadData">
                    <b-row class="mb-3">
                        <b-col cols="12">
                            <h3>Campos personalizables</h3>
                        </b-col>
                    </b-row>
                    <b-row class="mb-3">
                        <b-col cols="12" md="6" lg="6" class="mb-2" v-for="(field, index) in customFields" :key="field.field">
                            <b-form-group :label="`Campo ${index + 1}`" :state="field.state">
                                <b-input-group>
                                    <b-input-group-prepend is-text>
                                        <b-form-checkbox  class="mr-n2" v-model="field.enabled"></b-form-checkbox>
                                    </b-input-group-prepend>
                                        <b-form-input aria-label="Text input with switch" v-model="field.name" :placeholder="field.placeholder"
                                                      :disabled="!field.enabled" :state="field.state" @input="validateField(field)"></b-form-input>
                                    <b-form-select v-model="field.type" :disabled="!field.enabled"
                                                   :style="'max-width: 90px;' + (field.state === false ? 'border-left: 0; margin-left: 0' : '')">
                                        <b-form-select-option value="TEXT">Texto</b-form-select-option>
                                        <b-form-select-option value="DATETIME">Fecha</b-form-select-option>
                                    </b-form-select>
                                    <b-form-select v-model="field.required" style="max-width: 150px" :disabled="!field.enabled">
                                        <b-form-select-option :value="false">No requerido</b-form-select-option>
                                        <b-form-select-option :value="true">Requerido</b-form-select-option>
                                    </b-form-select>
                                </b-input-group>

                                <b-form-invalid-feedback class="text-left ml-5" :state="field.state">Ingresa el nombre del campo</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-2">
                        <b-col cols="12">
                            <b-alert variant="warning" show class="text-left">¡Advertencia!, Alterar el orden o modificar los campos personalizables después de la configuración inicial, puede llegar a producir inconsistencia de información.</b-alert>
                        </b-col>
                    </b-row>

                    <b-row class="mb-3">
                        <b-col>
                            <h3>Opciones predeterminadas</h3>
                        </b-col>
                    </b-row>

                    <b-row class="mb-5">
                        <b-col cols="12" md="6" class="mb-2" v-for="option in defaults" :key="option.name">
                            <b-form-checkbox  class="mr-n2" v-model="option.value">{{ option.label }}</b-form-checkbox>
                        </b-col>
                    </b-row>

                    <b-row class="mb-3">
                        <b-col>
                            <h3>Formato de fechas</h3>
                        </b-col>
                    </b-row>

                    <b-row class="mb-2">
                        <b-col cols="12" class="mb-4">
                            <strong>{{ dateFormatExample }}</strong><span class="mx-4"></span><strong>{{ dateFormatExample2 }}</strong>
                        </b-col>

                        <b-col cols="12" sm="6" md="3">
                            <b-form-group label="Campo 1">
                                <b-form-select v-model="dateFormat.first" placeholder="Primer campo" :options="dateFormatOptions"
                                               :state="dateFormatState"></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="6" md="3">
                            <b-form-group label="Campo 2">
                                <b-form-select v-model="dateFormat.second" placeholder="Segundo campo" :options="dateFormatOptions"
                                               :state="dateFormatState"></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="6" md="3">
                            <b-form-group label="Campo 3">
                                <b-form-select v-model="dateFormat.third" placeholder="Tercer campo" :options="dateFormatOptions"
                                               :state="dateFormatState"></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="6" md="3">
                            <b-form-group label="Separador">
                                <b-form-select v-model="dateFormat.separator" placeholder="Separador" :options="dateFormatSeparators"
                                               :state="dateFormatState"></b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-tab>
            </b-tabs>

            <template #footer v-if="showFooter">
                <b-row>
                    <b-col class="d-flex justify-content-end">
                        <b-button variant="primary" @click="saveSettings"><font-awesome-icon icon="save"></font-awesome-icon> Guardar</b-button>
                    </b-col>
                </b-row>
            </template>
        </b-card>
    </b-overlay>
</template>

<script>
import UserIndex from './User/Index';
import { settingUrl } from '@routes';
import * as constants from '@constants';

export default {
    props: {
        settings: Object,
        membership: Object,
        application: String,
        modules: Array
    },
    data() {
        return {
            customFields: [
                { id: 0, name: '', enabled: false, field: 'F1', type: 'TEXT', required: false, placeholder: 'Ej. Cotización' },
                { id: 0, name: '', enabled: false, field: 'F2', type: 'TEXT', required: false, placeholder: 'Ej. Orden de compra' },
                { id: 0, name: '', enabled: false, field: 'F3', type: 'TEXT', required: false, placeholder: 'Ej. Orden de servicio' },
                { id: 0, name: '', enabled: false, field: 'F4', type: 'TEXT', required: false, placeholder: 'Ej. Fecha de emisión' },
                { id: 0, name: '', enabled: false, field: 'F5', type: 'TEXT', required: false, placeholder: 'Ej. Campo 5' }
            ],
            settingsId: 0,
            defaults: {
                lockDownload: { label: 'Bloquear descarga y visualización de archivos', value: true }
                // attachFiles: { label: 'Enviar como archivos adjuntos', value: false }
            },
            dateFormat: {
                first: 'yyyy',
                second: 'MM',
                third: 'dd',
                separator: '-'
            },
            dateFormatOptions: [
                { value: 'd', text: 'Día (Ej. 1)', example: '1' },
                { value: 'dd', text: 'Día a dos dígitos (Ej. 01)', example: '01' },
                // { value: 'M', text: 'Mes (Ej. 1)', example: '1' },
                { value: 'MM', text: 'Mes a dos dígitos (Ej. 01)', example: '01' },
                { value: 'MMM', text: 'Mes abreviado (Ej. Ene)', example: 'Ene' },
                { value: 'MMMM', text: 'Mes completo (Ej. Enero)', example: 'Enero' },
                { value: 'yy', text: 'Año a 2 dígitos (Ej. 00)', example: '00' },
                { value: 'yyyy', text: 'Año a 4 dígitos (Ej. 2000)', example: '2000' }
            ],
            dateFormatSeparators: [
                { value: '-', text: 'Guiones (-)' },
                { value: '/', text: 'Diagonales (/)' },
                { value: '.', text: 'Puntos (.)' },
                { value: ' ', text: 'Espacios ( )' }
            ],
            theme: {
                variant: 'dark'
            },
            isLoading: false,
            showFooter: false
        }
    },
    components: {
        UserIndex
    },
    created() {
        this.changeTab('USER');
    },
    methods: {
        loadData() {
            this.isLoading = true;

            this.$parent.loadData().then(() => {
                this.settingsId = this.settings.id ?? 0;
                this.defaults.lockDownload.value = this.settings.defaults.lockDownload ?? false;
                // this.defaults.attachFiles.value = this.settings.defaults.attachFiles ?? false;

                this.dateFormat.first = this.settings.dateFormat.first ?? 'yyyy';
                this.dateFormat.second = this.settings.dateFormat.second ?? 'MM';
                this.dateFormat.third = this.settings.dateFormat.third ?? 'dd';
                this.dateFormat.separator = this.settings.dateFormat.separator ?? '-';

                for (let field of this.settings.customFields) {
                    let customField = this.customFields.find(customField => customField.field === field.field);

                    if (customField) {
                        customField.id = field.id;
                        customField.name = field.name;
                        customField.enabled = field.enabled;
                        customField.field = field.field;
                        customField.type = field.type;
                        customField.required = field.required;
                        customField.state = null;
                    }
                }
            }).finally(() => {
                this.isLoading = false;

                this.changeTab('GENERAL');
            });
        },
        saveSettings() {
            if (this.validateFields() && this.validateDateFormat()) {
                this.$swal({
                    title: '¿Guardar la configuración general?',
                    icon: 'question'
                }).then(result => {
                    if (result.value) {
                        let method = 'put';

                        if (this.settingsId === 0) {
                            method = 'post';
                        }

                        this.axios[method](settingUrl(), {
                            customFields: this.customFields,
                            setting: {
                                id: this.settingsId,
                                lockDownload: this.defaults.lockDownload.value,
                                // attachFiles: this.defaults.attachFiles.value,
                                attachFiles: false,
                                dateFormat: this.dateFormat
                            }
                        }).then(response => {
                            if (response.data.code === constants.CODE_OK) {
                                this.loadData();

                                this.$bvToast.toast(response.data.message, {
                                    title: 'Configuración general',
                                    variant: 'success'
                                });
                            } else if ('message' in response.data) {
                                this.$bvToast.toast(response.data.message, {
                                    title: 'Configuración general',
                                    variant: 'success'
                                });
                            } else {
                                this.$bvToast.toast('Ocurrió un error al guardar la configuración general.', {
                                    title: 'Configuración general',
                                    variant: 'success'
                                });
                            }
                        }).catch(() => {
                            this.$bvToast.toast('Ocurrió un error al guardar la configuración general.', {
                                title: 'Configuración general',
                                variant: 'danger'
                            });
                        });
                    }
                });
            }
        },
        changeTab(tab) {
            let breadcrumbItems = [
                {
                    text: 'Configuración',
                    to: { name: 'Settings' }
                }
            ];

            if (tab === 'USER') {
                breadcrumbItems.push({
                    text: 'Administradores',
                    active: true
                });

                this.showFooter = false;
            } else {
                breadcrumbItems.push({
                    text: 'General',
                    active: true
                });

                this.showFooter = true;
            }

            this.$emit('update-breadcrumb-items', breadcrumbItems);
        },
        validateField(field) {
            if (field.enabled && field.name.trim() === '') {
                field.state = false;
            } else {
                field.state = null;
            }

            this.$forceUpdate();
        },
        validateFields() {
            let isValid = this.customFields.every(field => !field.enabled || field.name.trim() !== '');

            if (!isValid) {
                this.customFields.forEach(field => {
                    this.validateField(field);
                });
            }

            return isValid;
        },
        validateDateFormat() {
            let isValid = true;
            let d = 0, m = 0, y = 0;

            for (let prop in this.dateFormat) {
                if (this.dateFormat[prop].includes('d')) {
                    d++;
                } else if (this.dateFormat[prop].includes('M')) {
                    m++;
                } else if (this.dateFormat[prop].includes('y')) {
                    y++;
                }
            }

            if (d !== 1 || m !== 1 || y !== 1) {
                isValid = false;
            }

            return isValid;
        }
    },
    watch: {
        theme: {
            handler() {
                let userSettings = null;

                if (localStorage.getItem('userSettings')) {
                    userSettings = JSON.parse(localStorage.getItem('userSettings'));

                    userSettings.theme = {
                        variant: this.theme.variant
                    };

                } else {
                    userSettings = {
                        theme: {
                            variant: this.theme.variant
                        }
                    };
                }

                localStorage.setItem('userSettings', JSON.stringify(userSettings));
            },
            deep: true
        }
    },
    computed: {
        dateFormatState() {
            return this.validateDateFormat() ? null : false;
        },
        dateFormatExample() {
            let format = this.dateFormat;
            let first = this.dateFormatOptions.find(option => option.value === format.first).example;
            let second = this.dateFormatOptions.find(option => option.value === format.second).example;
            let third = this.dateFormatOptions.find(option => option.value === format.third).example;
            let separator = format.separator;

            return `${first}${separator}${second}${separator}${third}`;
        },
        dateFormatExample2() {
            let format = this.dateFormat;
            let first = this.dateFormatOptions.find(option => option.value === format.first).value.toUpperCase().replace(/Y/g, 'A');
            let second = this.dateFormatOptions.find(option => option.value === format.second).value.toUpperCase().replace(/Y/g, 'A');
            let third = this.dateFormatOptions.find(option => option.value === format.third).value.toUpperCase().replace(/Y/g, 'A');
            let separator = format.separator;

            return `${first}${separator}${second}${separator}${third}`;
        },
        BACK_OFFICE_USER() {
            return constants.BACK_OFFICE_USER;
        },
        PORTAL_USER() {
            return constants.PORTAL_USER;
        }
    }
}
</script>

<style>

</style>